export default __webpack_public_path__ + "static/media/2222.356d683c.png";